import { RouterProvider } from 'react-router-dom';
import { Loading } from '@leegality/leegality-react-component-library';
import AppProvider from '@app/providers/app-provider';
import { appRouter } from './routes';

const App = () => {
  return (
    <AppProvider>
      <RouterProvider
        router={appRouter}
        fallbackElement={<Loading />}
      />
    </AppProvider>
  );
};

export default App;
